import { Invoice, PayerApprovalStatus } from "@wingspanhq/wingspan-api-sdk";

/**
 * Whether a v3 invoice is currently rejected by its payer — declined, and not
 * since resubmitted by the payee.
 *
 * The v3 shape of the v1 `getIsInvoiceRejected`: the declined state moved from
 * the embedded client workflow status to `payerApprovalStatus`, while both
 * timestamps kept their names.
 */
export const selectorIsInvoiceRejected = (invoice: Invoice): boolean =>
  invoice.payerApprovalStatus === PayerApprovalStatus.DECLINED &&
  (!invoice.events?.memberResubmittedAt ||
    (!!invoice.events?.clientDeclinedAt &&
      invoice.events.clientDeclinedAt > invoice.events.memberResubmittedAt));
